const transitions = {
  default: `all ease-out 0.2s`,
};

export { transitions };
